import React from 'react';
import { Spin } from 'antd';
import AppTheme from '../../theme/AppTheme';

const Loading = () => {
    return <div style={{ backgroundColor: AppTheme.colors.background }} className="w-screen h-screen absolute flex items-center justify-center overflow-auto">
        <div className="text-center flex-grow">
            <Spin size="large" />
        </div>
    </div>
}

export default Loading;